// @flow
import client from '../../client'
import format from '../../utils/format'

// Types
export type RequestData = {
  token: string,
  password: string,
}

// API Endpoints
export const USER_CONFIRM_RESET_PASSWORD = '/auth/reset-password/confirm/{0}/'

/**
 * Verifies the token from reset password email
 * @param  {string} data.token token
 * @param  {string} data.password New password
 * @return {Promise|Error} A resolved Promise or Rejected with an Error
 */
export const confirmResetPassword = ({
  token,
  password,
}: RequestData): Promise<boolean> => {
  const endpoint = format(USER_CONFIRM_RESET_PASSWORD, token)

  return client
    .post(endpoint, { body: { password } })
    .then((response) => response.success)
}

export default confirmResetPassword
